export default __webpack_public_path__ + "static/media/madhya-pradesh-map.c2885423.jpg";